import React, { useState } from "react";
import { Divider, Grid, Tab, Typography } from "@mui/material";
import keyLabel from "../../../../utils/keylabel";
import { CalendarObjectInnerDayEnum } from "../../../../api/clinic-management";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import AvailabilityFields from "../FormFields/AvailabilityFields";

const weekDays = keyLabel(CalendarObjectInnerDayEnum);

export default function EmployeeAvailability() {
  const [selectedTab, setSelectedTab] = useState<string>("0");

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Employee Availability
      </Typography>
      <Divider />
      <Grid sx={{ display: "flex", flexGrow: 1, m: 2, ml: { xs: -10, sm: 1 }, width: "100%" }}>
        <TabContext value={selectedTab}>
          <Grid sx={{ borderBottom: 1, borderColor: "divider", p: 4 }}>
            <TabList
              onChange={handleChangeTab}
              centered
              textColor="secondary"
              indicatorColor="secondary"
              orientation="vertical"
              sx={{ borderRight: 1, borderColor: "divider" }}
            >
              {weekDays.map((day: any, index: number) => (
                <Tab label={day.value} value={`${index}`} key={index} />
              ))}
            </TabList>
          </Grid>
          <Grid container sx={{ m: 2, ml: { xs: -5, sm: 1 } }}>
            {weekDays.map((day: any, index: number) => {
              return (
                <TabPanel value={`${index}`} key={index}>
                  <AvailabilityFields day={day.value} />
                </TabPanel>
              );
            })}
          </Grid>
        </TabContext>
      </Grid>
    </>
  );
}
